// Removing licences (anima_core #8, 08.10.2026). "Entfernen" archives: the
// hub keeps the row, hides it from the list unless asked, and activate and
// verify no longer know it. Admin only, as on the hub. Pure, no imports: the
// node tests load this file directly (licence_rows.test.ts).

/** What these functions read of a licence row. */
export interface LicenceRow {
    uuid: string;
    archived?: boolean | null;
}

/** Whether the licence is archived; an older hub sends no field - not archived. */
export const isArchived = (row: LicenceRow): boolean => row.archived === true;

/** Whether the "Entfernen" button is offered: admins, for a licence not removed yet. */
export const mayRemove = (row: LicenceRow, isAdmin: boolean): boolean => isAdmin && !isArchived(row);

/** Whether "Wiederherstellen" is offered: admins, for a removed licence. */
export const mayRestore = (row: LicenceRow, isAdmin: boolean): boolean => isAdmin && isArchived(row);
